/* RESPONSIBLE TEAM: team-automation-foundations */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

export default class RemoveConversationPriority extends Step {
  get supportedChannels() {
    return SUPPORTED_CHANNELS.removeConversationPriority;
  }

  static get supportedContexts() {
    return [
      TargetContext.Conversation,
      TargetContext.CustomerTicket,
      TargetContext.BackOfficeTicket,
      TargetContext.TrackerTicket,
    ];
  }

  static get requiredBillingFeature() {
    return 'inbox_priority_rules';
  }

  static createNewStep(store: Store): RemoveConversationPriority {
    return store.createRecord('operator/visual-builder/step/remove-conversation-priority', {
      type: 'operator/visual-builder/step/remove-conversation-priority',
    });
  }
}
